import { render } from "./LottieAnimation.vue?vue&type=template&id=22697652&scoped=true&ts=true"
import script from "./LottieAnimation.vue?vue&type=script&lang=ts"
export * from "./LottieAnimation.vue?vue&type=script&lang=ts"

import "./LottieAnimation.vue?vue&type=style&index=0&id=22697652&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22697652"]])

export default __exports__